// extracted by mini-css-extract-plugin
export const loginAppIcon = "b_b";
export const signupGroup = "b_c";
export const txtTitle = "b_d";
export const txtSubTitle = "b_f";
export const input = "b_g";
export const txtTermPrivacy = "b_h";
export const btnSignup = "b_j";
export const txtHaveAcc = "b_k";
export const tAndCGroup = "b_l";
export const errorMsg = "b_m";